import React from 'react'
import { WemoloTypography } from '../../components/Wemolo'
import styles from './DegradedModeAlert.module.css'

interface DegradedModeAlertProps {
    errors: string[]
}

export const DegradedModeAlert: React.FC<DegradedModeAlertProps> = ({ errors }) => {
    if (!errors?.length) {
        return null
    }

    return (
        <div className={styles.root}>
            <WemoloTypography variant="body-small-emphasized" tag="div">
                ⚠️ App is operating in degraded mode, affected features:{' '}
                {errors.map((error, index) => (
                    <div key={index}>
                        <b>{error}</b>
                    </div>
                ))}
            </WemoloTypography>
        </div>
    )
}
